export const applySteps: string[] = [
  "Applicant Information",
  "Employment Information",
  "Fee summary and Comments",
  "Submit"
];

export const totalApplySteps = applySteps.length;
